import { AccountTieHatOutlineIcon } from './AccountTieHatOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8097E3AA-0C0F-47BE-9700-DEAF4986E6AE
 * name account-tie-hat-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-tie-hat-outline.svg
 * tags
 * - Account / User 
 * - Transportation + Flying 
 */
export const AccountPilotOutlineIcon = AccountTieHatOutlineIcon;
export default AccountPilotOutlineIcon